import * as React from 'react';
export const IcHeartRate = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M15.6 4A5.6 5.6 0 0012 5.46 5.6 5.6 0 008.4 4 5.36 5.36 0 003 9.44c.002.526.07 1.05.2 1.56h2.26l1.71-2.55A1 1 0 018.06 8a1 1 0 01.83.55L11.12 13l1.05-1.56A1 1 0 0113 11h2a1 1 0 010 2h-1.46l-1.71 2.55A1 1 0 0111 16h-.06a1 1 0 01-.83-.55L7.88 11l-1 1.56A1 1 0 016 13H4c1.15 2.14 3.27 4.35 6.18 7l.49.45a2 2 0 002.7 0l.49-.44C18.37 15.86 21 12.8 21 9.44A5.36 5.36 0 0015.6 4z'
      fill='currentColor'
    />
  </svg>
);
